<template>
  <div>
    <USpin :tip="indicatorState.tip" :loading="indicatorState.loading" fit-view>
      <div class="flex justify-center min-w-full min-h-full main-page">
        <router-view v-slot="{ Component, route }">
          <transition name="fade" mode="out-in" appear>
            <component
              :is="getComponent(Component, route)"
              v-if="route.meta.ignoreCache"
              :key="route.meta.reuse ? route.path : route.fullPath"
            />
          </transition>
          <keep-alive :max="10">
            <component
              :is="getComponent(Component, route)"
              v-if="!route.meta.ignoreCache"
              :key="route.meta.reuse ? route.path : route.fullPath"
            />
          </keep-alive>
        </router-view>
      </div>
    </USpin>
  </div>
</template>

<script lang="ts" setup>
import { useIndicatorState } from '@/hooks/useIndicator'


function getComponent(Component: any, route: any) {
  // return (import.meta.env.VITE_MOD === 'pro' && route.meta.deving) ? Developing: Component
  return Component
}
const indicatorState = useIndicatorState()
</script>

<style scoped lang="less"></style>
